import React from "react";
import { useTranslation } from 'react-i18next';
import QuarriesAntalyaElmali2 from "../Components/quarries/QuarriesAntalyaElmali2";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";

function AntalyaElmali2Page() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = {
    title: currentLang === 'tr' ? 'Antalya Elmalı 2 Ocağı Mermerleri - MOCA Mermer' : 'Antalya Elmali 2 Quarry Marbles - MOCA Marble',
    description: currentLang === 'tr' ? 'Antalya Elmalı 2 mermer ocağından çıkarılan Letoon Beige ve Shandian Beige mermer çeşitleri.' : 'Letoon Beige and Shandian Beige marble varieties from Antalya Elmali 2 quarry.',
    keywords: currentLang === 'tr' ? 'antalya elmalı 2 ocak, letoon beige, shandian beige, mermer çeşitleri' : 'antalya elmali 2 quarry, letoon beige, shandian beige, marble varieties'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/antalyaelmali2"
      />
      <TopBar />
      <Spacer />
      <QuarriesAntalyaElmali2 />
    </>
  );
}

export default AntalyaElmali2Page;
